import { PreferredTimeModel } from "./dataStructures";
import { convertTimePickerToServerTime } from "./utilityFunctions";

export function giveFormDataFromPrefTime(
  user_id: string,
  pref_time: PreferredTimeModel
) {
  let form: FormData = new FormData();
  form.append("user_id", user_id);
  form.append("name", pref_time.day_key);
  form.append("start_at", convertTimePickerToServerTime(pref_time.start_time));
  form.append("end_at", convertTimePickerToServerTime(pref_time.end_time));
  return form;
}

export function giveURLSchemeFromPrefTime(
  user_id: string,
  pref_time: PreferredTimeModel
) {
  let params: URLSearchParams = new URLSearchParams();
  if (pref_time.day_id !== undefined) {
    params.append("id", pref_time.day_id);
  }
  params.append("user_id", user_id);
  params.append("name", pref_time.day_key);
  params.append(
    "start_at",
    convertTimePickerToServerTime(pref_time.start_time)
  );
  params.append("end_at", convertTimePickerToServerTime(pref_time.end_time));
  return params;
}
